import UsageStatsText from 'pages/UsageStatsTexts/page';
import React from 'react';
import { Route } from 'react-router-dom';

export const USAGE_STATS_ROUTES = [
    <Route index path='texts' element={<UsageStatsText />} />,
];
